export default __webpack_public_path__ + "images/RK.106485e.png";